<template>
	<Group
		:state="dataValid"
		:invalid-feedback="error"
		feedback-beneath
	>
		<div class="d-flex align-items-center">
			<div class="mr-2">Von</div>
			<b-input
				v-model="min"
				class="d-inline-block"
				style="width: 6rem"
				placeholder="zB: 20"
				@input="emitChangeEvent"
			/>
			<div class="mx-2">&euro; bis</div>
			<b-input
				v-model="max"
				class="d-inline-block"
				style="width: 6rem"
				placeholder="zB: 50"
				@input="emitChangeEvent"
			/>
			<div class="ml-2">&euro; pro Stunde</div>
		</div>
	</Group>
</template>

<script>
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull} from "@/helper/String";
import {isPositiveInteger} from "@/helper/Number";
import Group from "@/vue/common/form/Group.vue";
import FormGroup from "@/vue/common/form/Group.vue";

export default {

	components: {
		FormGroup,
		Group,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		return {
			min: this.value?.min || '',
			max: this.value?.max || '',
		};
	},

	computed: {
		error ()
		{
			if (isEmptyOrNull(this.min) || isEmptyOrNull(this.max))
			{
				return 'Bitte gib den Stundensatz ein';
			}

			if (!isPositiveInteger(this.min) || !isPositiveInteger(this.max))
			{
				return 'Bitte gib nur Ziffern ein';
			}

			if (parseInt(this.min) > parseInt(this.max))
			{
				return 'Der Mindest-Stundensatz darf nicht höher sein als der Maximal-Stundensatz';
			}

			return null;
		},
		dataValid ()
		{
			return !isDefined(this.error);
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);

				return;
			}

			this.$emit('input', {
				min: this.min,
				max: this.max,
			});
		}
	}
}
</script>
